import { useQuery } from '@apollo/client';
import type { AudienceOption } from '@openx/types/targeting/audience.ts';
import type { AudienceOptionsMap } from '@openx/types/targeting/targetingHookTypes.ts';
import { GetAudienceDocument } from '../../../graphql/query/audiences/GetAudience.generated.tsx';

export function useAudienceOptionsDetailsFetch(
  _accountUid: string,
  _type: AudienceOption | null,
  vals?: string[] | null
) {
  const selectedAudience = vals?.[0] ?? '';
  const {
    data: { audience_by_pk: audience } = {},
    loading: isLoading,
    refetch,
  } = useQuery(GetAudienceDocument, {
    skip: selectedAudience === '',
    variables: {
      id: selectedAudience.replace('openaudience-', ''),
    },
  });

  let options = {} as AudienceOptionsMap;

  if (audience) {
    options = { [selectedAudience]: audience };
  }

  return {
    isLoading,
    options,
    refetch,
  };
}
